const indexItems = [
  {
    icon: "ri-fire-line",
    title: "今日最热爆料",
    desc: "实时更新的每日大赛新瓜汇总，一站式浏览今天最劲爆的内容。",
    count: "32条",
  },
  {
    icon: "ri-trophy-line",
    title: "周度榜单揭晓",
    desc: "mrds榜单揭晓每周最受关注话题排名，热门程度一目了然。",
    count: "TOP20",
  },
  {
    icon: "ri-emotion-laugh-line",
    title: "搞笑内容合集",
    desc: "精选擦边搞笑名场面，让你在吃瓜之余也能开怀大笑。",
    count: "50+",
  },
  {
    icon: "ri-search-eye-line",
    title: "黑料深度调查",
    desc: "独家深扒热门话题背后的真相，mrds每日爆料不止于表面。",
    count: "18篇",
  },
  {
    icon: "ri-chat-smile-2-line",
    title: "读者热议话题",
    desc: "最受读者关注的mrds热门话题讨论区，看看大家都在聊什么。",
    count: "热议",
  },
  {
    icon: "ri-vidicon-line",
    title: "视频爆料专区",
    desc: "视频形式的每日爆料内容，更直观地了解事件来龙去脉。",
    count: "25个",
  },
  {
    icon: "ri-user-voice-line",
    title: "匿名投稿入口",
    desc: "你有独家线索？通过匿名渠道向我们投稿，安全又便捷。",
    count: "投稿",
  },
  {
    icon: "ri-calendar-check-line",
    title: "每日更新日历",
    desc: "大赛每日更新时间表，不错过任何一个榜单看点的刷新时刻。",
    count: "24h",
  },
  {
    icon: "ri-shield-check-line",
    title: "内容真实性核查",
    desc: "我们对每一条爆料进行核查标记，帮助读者辨别信息可信度。",
    count: "已核",
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-10 text-center">
          专题索引
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href="#about"
              className="group flex items-start gap-4 bg-background-100 rounded-2xl p-5 hover:bg-primary-50/40 transition-colors duration-200 cursor-pointer"
            >
              <div className="w-11 h-11 flex-shrink-0 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-200">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-1">
                  <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors duration-200">
                    {item.title}
                  </h3>
                  <span className="text-xs text-foreground-400 bg-background-200/70 px-2 py-0.5 rounded-full whitespace-nowrap ml-2">
                    {item.count}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}